module.exports = __webpack_public_path__ + "img/ice_car.2fb47992.png";